import { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";

/**
 * Overlay de espera para correções LLM, que levam 60-200s. Sem isto a tela
 * fica estática e a estudante acha que travou e recarrega (perdendo o envio).
 * Mostra tempo decorrido, mensagens rotativas e barra indeterminada.
 */
export function GradingProgress({
  active,
  steps,
}: {
  active: boolean;
  steps?: string[];
}) {
  const messages =
    steps && steps.length > 0
      ? steps
      : [
          "Lendo sua resposta…",
          "Comparando com a abordagem esperada da banca…",
          "Avaliando critério por critério…",
          "Identificando lacunas e o erro predominante…",
          "Montando o feedback e o plano de reescrita…",
        ];

  const [elapsed, setElapsed] = useState(0);
  const [stepIdx, setStepIdx] = useState(0);

  useEffect(() => {
    if (!active) {
      setElapsed(0);
      setStepIdx(0);
      return;
    }
    const tick = setInterval(() => setElapsed((s) => s + 1), 1000);
    const rotate = setInterval(
      () => setStepIdx((i) => (i + 1) % messages.length),
      6000,
    );
    return () => {
      clearInterval(tick);
      clearInterval(rotate);
    };
  }, [active, messages.length]);

  if (!active) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-0 z-50 flex items-center justify-center bg-[color:var(--color-background)]/80 backdrop-blur-sm"
    >
      <div className="mx-4 w-full max-w-md rounded-2xl border border-[--color-border] bg-[color:var(--color-card)] p-8 text-center shadow-xl">
        <Sparkles className="mx-auto size-7 text-[color:var(--color-accent)]" aria-hidden />
        <p className="mt-4 text-[length:var(--text-body)] font-medium">
          {messages[stepIdx]}
        </p>
        <div className="mt-5 h-1.5 overflow-hidden rounded-full bg-[color:var(--color-muted)]">
          <div className="h-full w-1/3 animate-grading-bar rounded-full bg-[color:var(--color-accent)]" />
        </div>
        <p className="mt-4 text-[length:var(--text-caption)] text-[color:var(--color-muted-foreground)]">
          Correção detalhada por IA — costuma levar de 1 a 3 minutos. Não feche
          nem recarregue a página. ({elapsed}s)
        </p>
      </div>
    </div>
  );
}
